// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badge {
  display: flex;
  padding: 0.5rem 1rem;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  border-radius: 0.4rem;
  border: 1px solid var(--Accent-colors-Tags-and-status-Green-BR, #9DE09D);
  background: var(--Accent-colors-Tags-and-status-Green-BG, #EBF9EB);
}`, "",{"version":3,"sources":["webpack://./src/shared/table/renderers/table-cell-status-renderer/table-cell-status-renderer.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,wEAAA;EACA,kEAAA;AACF","sourcesContent":[".badge {\n  display: flex;\n  padding: 0.5rem 1rem;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  border-radius: 0.4rem;\n  border: 1px solid var(--Accent-colors-Tags-and-status-Green-BR, #9DE09D);\n  background: var(--Accent-colors-Tags-and-status-Green-BG, #EBF9EB);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
